import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { remark } from 'remark';
import remarkToReact from 'remark-react';
import { MdClose as CloseIcon, MdWarning as WarningIcon } from 'react-icons/md';

export const STORAGE_KEY = 'hiddenServiceAnnouncements';

const dummy = () => null;

const ServiceAnnouncement = ({ message, closeAnnouncement = dummy }) => {
  const { communicationId, title, bodyText } = message;

  const bodyTextWithTitle = `**${title}** — ${bodyText}`;

  const formattedContent = remark().use(remarkToReact, React).processSync(bodyTextWithTitle).result;

  const handleClose = useCallback(
    () => closeAnnouncement(communicationId),
    [closeAnnouncement, communicationId]
  );

  return (
    <div className="service-announcement-panel">
      <div className="service-announcement-warning-icon">
        <WarningIcon />
      </div>
      <div className="service-announcement-content">
        {formattedContent}
      </div>
      <div className="service-announcement-close-icon">
        <CloseIcon onClick={handleClose} />
      </div>
    </div>
  );
};

ServiceAnnouncement.propTypes = {
  message: PropTypes.shape({
    communicationId: PropTypes.number,
    title: PropTypes.string.isRequired,
    bodyText: PropTypes.string.isRequired,
  }),
  closeAnnouncement: PropTypes.func,
};

export default ServiceAnnouncement;
